import { render } from "./PostDetailPage.vue?vue&type=template&id=699ffed5&scoped=true&ts=true"
import script from "./PostDetailPage.vue?vue&type=script&lang=ts"
export * from "./PostDetailPage.vue?vue&type=script&lang=ts"

import "./PostDetailPage.vue?vue&type=style&index=0&id=699ffed5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699ffed5"]])

export default __exports__